<template>
    <span class="pull-right-container">
        <small class="label pull-right bg-green" v-if="unreadEventsCount > 0">{{ unreadEventsCount}}</small>
    </span>
</template>

<script>
    import { EventBus } from "../../eventBus";

    export default {
        props: ['initUnreadEventsCount'],
        data: function () {
            return {
                unreadEventsCount: this.initUnreadEventsCount
            }
        },
        created() {
            EventBus.on('eventRead', () => {
                this.unreadEventsCount --;
            })
        },
    }
</script>
